import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';
import Icon from 'js/components/common/Icon';
import { formatCurrency } from 'js/services/Format';


const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  align-self: flex-end;
  justify-self: flex-end;
  padding-right: 5px;
  @media(min-width: ${device.mobile}) {
    padding-bottom: 20px;
  }
  @media(min-width: ${device.tablet}) {
    padding-bottom: 10px;
  }
  @media(min-width: ${device.laptop}) {
    padding-bottom: 0px;
  }
`;

const PriceDisplay = styled.h6`
  font-size: 16px;
  margin: 0;
`;

export default({ price, link, onAction }) => (
  <Container>
    <PriceDisplay>
      <strong>{formatCurrency(price)}</strong>
    </PriceDisplay>
    <a onClick={() => onAction()}><Icon name="share-square-o" /></a>
  </Container>
);
